'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var cleanPhone = function cleanPhone(phone) {
  var cleaned = ('' + phone).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return '';
};
var ArticleInfoBlock = function ArticleInfoBlock(_ref) {
  var className = _ref.className,
    name = _ref.name,
    phone = _ref.phone,
    email = _ref.email,
    topics = _ref.topics;
  var classes = index.default('article-info-block', className);
  var renderContact = function renderContact() {
    return name && /*#__PURE__*/React__default.default.createElement("div", {
      className: "section"
    }, /*#__PURE__*/React__default.default.createElement("h3", {
      className: "block-header"
    }, "Contact"), /*#__PURE__*/React__default.default.createElement("p", {
      className: "info weight-600"
    }, /*#__PURE__*/React__default.default.createElement("span", {
      className: "link"
    }, name), !email ? /*#__PURE__*/React__default.default.createElement("a", {
      href: "tel:".concat(phone)
    }, cleanPhone(phone)) : /*#__PURE__*/React__default.default.createElement("span", {
      className: "link"
    }, /*#__PURE__*/React__default.default.createElement("a", {
      href: "tel:".concat(phone)
    }, cleanPhone(phone))), email && /*#__PURE__*/React__default.default.createElement("a", {
      href: "mailto:".concat(email),
      type: "button",
      className: "email",
      "aria-label": email
    }, email)));
  };
  var renderTopics = function renderTopics() {
    return topics.length > 0 && /*#__PURE__*/React__default.default.createElement("div", {
      className: "section topics"
    }, /*#__PURE__*/React__default.default.createElement("h3", {
      className: "block-header"
    }, "Topics"), /*#__PURE__*/React__default.default.createElement("ul", {
      className: "info topic-list list-unstyled"
    }, topics.map(function (_ref2) {
      var slug = _ref2.slug,
        tag_name = _ref2.tag_name;
      return /*#__PURE__*/React__default.default.createElement("li", {
        key: "topic-link-".concat(tag_name)
      }, /*#__PURE__*/React__default.default.createElement("a", {
        className: "link link-topic",
        href: "/news/".concat(slug, "/")
      }, tag_name));
    })));
  };
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes
  }, renderContact(), renderTopics());
};
ArticleInfoBlock.defaultProps = {
  topics: []
};
ArticleInfoBlock.propTypes = {
  name: PropTypes__default.default.string.isRequired,
  phone: PropTypes__default.default.string.isRequired,
  topics: PropTypes__default.default.array.isRequired,
  className: PropTypes__default.default.string,
  email: PropTypes__default.default.string
};

exports.ArticleInfoBlock = ArticleInfoBlock;
exports.cleanPhone = cleanPhone;
exports.default = ArticleInfoBlock;
//# sourceMappingURL=ArticleInfoBlock.js.map
